import { render, staticRenderFns } from "./Journals.vue?vue&type=template&id=6a613306&scoped=true&"
import script from "./Journals.vue?vue&type=script&lang=js&"
export * from "./Journals.vue?vue&type=script&lang=js&"
import style0 from "./Journals.vue?vue&type=style&index=0&id=6a613306&scoped=true&lang=css&"
import style1 from "./Journals.vue?vue&type=style&index=1&lang=css&"
import style2 from "./Journals.vue?vue&type=style&index=2&id=6a613306&lang=scss&scoped=true&"
import style3 from "./Journals.vue?vue&type=style&index=3&lang=scss&"
import style4 from "./Journals.vue?vue&type=style&index=4&id=6a613306&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a613306",
  null
  
)

export default component.exports